import http from '@services/http'

export default {
  // 查询定点推送给学者的文章记录
  getRecommendRecord(data?: object): Promise<any> {
    return http.get('user-api/processRecord/recommendRecord', data || {})
  },

  // 查询定点推送给学者的文章记录
  getReadArticle(data?: object): Promise<any> {
    return http.get('user-api/processRecord/readArticle', data || {})
  },

  // 查询学者收藏的文章记录
  getCollectArticle(data?: object): Promise<any> {
    return http.get('user-api/processRecord/collectArticle', data || {})
  },

  // 查询学者的订阅信息
  getSubscribeList(data?: any): Promise<any> {
    return http.get('user-api/subscribe/list', data || {})
  },

  // 保存用户阅读记录
  saveReadArticle(data: object): Promise<any> {
    return http.post('user-api/processRecord/saveReadArticle', data || {})
  },

  // 保存用户Tag
  saveTag(data: object): Promise<any> {
    return http.post('user-api/processRecord/saveTag', data || {})
  }
}
